// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-290cbb19]{border:.15em solid;border-radius:50%;border-right:.15em solid transparent;vertical-align:text-bottom}@keyframes spinner-border-290cbb19{to{transform:rotate(1turn)}}.spinner[data-v-290cbb19]{animation:spinner-border-290cbb19 .75s linear infinite}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
